<br><br>
<mat-nav-list>
  <div class="profile-card">
    <div class="header">
      <h3>Abdelkader</h3>
      <h4 style="color: grey">Finance Factory</h4>
    </div>
    <img src="assets/img/10.jpg" alt="Abdelkader BOUSABAA">
  </div>
</mat-nav-list>

<br>
<mat-divider></mat-divider>
<br>

<a class="dropdown-item" style="color: whitesmoke" routerLinkActive="active" routerLink="/home">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-home"></i>
    </div>
    <div class="col-10">
      <span>Home</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(94,187,75)" routerLinkActive="active" routerLink="/resources/portfolio-models">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-chart-bar"></i>
    </div>
    <div class="col-10">
      <span>Portfolio Models</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(94,187,75)" routerLinkActive="active" routerLink="/resources/glossary">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-book-reader"></i>
    </div>
    <div class="col-10">
      <span>Glossary</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(94,187,75)" routerLinkActive="active" routerLink="/resources/papers">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-leaf"></i>
    </div>
    <div class="col-10">
      <span>White Papers</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(94,187,75)" routerLinkActive="active" routerLink="/resources/webinars">
  <div class="row">
    <div class="col-2">
      <i class="fa fa-film"></i>
    </div>
    <div class="col-10">
      <span>Web Seminars</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(94,187,75)" routerLinkActive="active" routerLink="/resources/events">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-calendar-alt"></i>
    </div>
    <div class="col-10">
      <span>Events</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: whitesmoke" routerLinkActive="active" (click)="onSignOut()">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-sign-out-alt"></i>
    </div>
    <div class="col-10">
      <span>Sign out</span>
    </div>
  </div>
</a>

<!--
<br>
<mat-divider></mat-divider>
<br><br>

<app-news-feed></app-news-feed>
-->
